import { ServiceBase } from "../ServiceBase";
import { IWalletProxyService } from "./wallet-proxy.service.interface";
import { action, observable, makeObservable } from "mobx";
import { IServiceFactoryExtended } from "../service-factory-extended.interface";
import { BalanceType } from "../../../common/const/wallet_balance_type";

export class WalletProxyService extends ServiceBase implements IWalletProxyService {

    @observable
    public bankroll: Record<BalanceType, string> = {
        [BalanceType.CASH]: '',
        [BalanceType.BONUS]: '',
        [BalanceType.BOTH]: '',
    };

    @observable
    public plainNumberBankroll: Record<BalanceType, number> = {
        [BalanceType.CASH]: 0,
        [BalanceType.BONUS]: 0,
        [BalanceType.BOTH]: 0,
    };

    get totalBankroll(): number {
        return this.plainNumberBankroll[BalanceType.BOTH] || 0;
    }

    get cashBankroll(): number {
        return this.plainNumberBankroll[BalanceType.CASH] || 0;
    }

    get bonusBankroll(): number {
        return this.plainNumberBankroll[BalanceType.BONUS] || 0;
    }

    constructor(serviceFactory: IServiceFactoryExtended) {
        super(serviceFactory);

        makeObservable(this);

        this.subscribe();
        this.fetchAllData();
    }

    @action.bound
    private setBankroll(bankroll: string, plainNumber: number, bType: BalanceType) {
        this.bankroll[bType] = bankroll;
        this.plainNumberBankroll[bType] = plainNumber;
    }

    /**
     * When the BALANCE_UPDATED from CGP is fired, the bankroll balance must pe updated
     */
    private subscribe() {
        this.services.sdk.events.onBalanceUpdated(() => {
            this.fetchAllData();
        });
        this.services.sdk.events.onOAuthStateChanged(() => {
            this.fetchAllData();
        })
    }

    private fetchAllData() {
        for (const bankrollType of Object.values(BalanceType)) {
            const {bankroll, plainNumber} = this._getData(bankrollType);
            this.setBankroll(bankroll, plainNumber, bankrollType);
        }
    }

    // retrieve bankroll data from Wallet
    private _getData(bankrollType: BalanceType): {bankroll: string, plainNumber: number} {
        let bankroll = '';
        let plainNumber: number = NaN;

        if (this.services.user.isAuthorized) {
            bankroll = this.services.sdk.getBankroll(bankrollType) as string;
            plainNumber = this.services.sdk.getBankroll(bankrollType, true) as number;
        }
        return {bankroll, plainNumber};
    }

}
